/* ▸ ADA #2 · スライドショーのフォーカス管理
 *
 * 9.2.0 のスライドショーは非アクティブなスライドの外側 <div> に aria-hidden="true"
 * を付ける。その中のリンクは focusable のままなので「aria-hidden な要素が focusable」
 * (WCAG 4.1.2 / axe: aria-hidden-focus) 違反になる。
 *
 * aria-hidden の状態に合わせて内部の操作可能要素の tabindex を同期する。
 * - 非アクティブなスライド … tabindex="-1"（AT からも Tab からも外れる）
 * - アクティブなスライド   … tabindex を復元（aria-label 付きで通常どおり操作可能）
 *
 * さらに autoplay でアクティブスライドが切り替わったとき、フォーカスが
 * aria-hidden の内側に取り残されないように、可視スライド側へ退避させる。
 *
 * see /CUSTOMIZATIONS.md §4
 */
(function () {
  var SLIDE = '.slideshow__slide';
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  var OBSERVED = 'data-ada-focus-observed';

  function focusableIn(el) {
    return el.querySelectorAll(FOCUSABLE);
  }

  function isHidden(slide) {
    return slide.getAttribute('aria-hidden') === 'true';
  }

  /* フォーカスが隠されたスライド内に残る場合の退避先を決める。
     優先: 可視スライド内の操作可能要素 → スライドショー全体のラッパー */
  function rescueFocus(hiddenSlide) {
    var active = document.activeElement;
    if (!active || !hiddenSlide.contains(active)) return;

    var wrapper = hiddenSlide.closest('.slideshow-wrapper') || hiddenSlide.parentElement;
    if (!wrapper) return;

    var slides = wrapper.querySelectorAll(SLIDE);
    for (var i = 0; i < slides.length; i++) {
      if (isHidden(slides[i])) continue;
      var candidates = focusableIn(slides[i]);
      for (var j = 0; j < candidates.length; j++) {
        if (candidates[j].getAttribute('tabindex') !== '-1') {
          candidates[j].focus();
          return;
        }
      }
    }

    /* 可視スライドに操作可能要素が無い場合はラッパーへ退避（見た目は変えない） */
    if (!wrapper.hasAttribute('tabindex')) wrapper.setAttribute('tabindex', '-1');
    wrapper.focus();
  }

  function syncSlide(slide) {
    var hidden = isHidden(slide);
    var items = focusableIn(slide);

    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (hidden) {
        if (el.getAttribute('tabindex') !== '-1') {
          el.setAttribute('data-ada-tabindex', el.getAttribute('tabindex') || '');
          el.setAttribute('tabindex', '-1');
        }
      } else if (el.hasAttribute('data-ada-tabindex')) {
        var prev = el.getAttribute('data-ada-tabindex');
        if (prev) el.setAttribute('tabindex', prev);
        else el.removeAttribute('tabindex');
        el.removeAttribute('data-ada-tabindex');
      }
    }

    /* 退避は次フレームまで遅らせる。スライド切替の瞬間は新しいアクティブスライドの
       aria-hidden がまだ外れておらず、可視スライドを見つけられないことがあるため。 */
    if (hidden && slide.contains(document.activeElement)) {
      var raf = window.requestAnimationFrame || function (fn) { return setTimeout(fn, 16); };
      raf(function () { rescueFocus(slide); });
    }
  }

  function observe(slide) {
    /* 同じスライドに二重で observer を付けない（テーマエディタの再描画対策） */
    if (slide.getAttribute(OBSERVED) === 'true') return;
    slide.setAttribute(OBSERVED, 'true');
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'aria-hidden') syncSlide(mutations[i].target);
      }
    }).observe(slide, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var slides = scope.querySelectorAll(SLIDE);
    for (var i = 0; i < slides.length; i++) {
      syncSlide(slides[i]);
      observe(slides[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* テーマエディタでセクションが再描画された場合は、その範囲だけ再適用する */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();
